module.exports = __webpack_public_path__ + "img/OpcioA_400x400.a4d4fe2f.png";